(ns admin.containers.learner-reports-activity
  (:require [re-frame.core :as re-frame]
            [kyber.styles.core :refer [styles->classes gs]]
            [kyber.lib.kyber-db :as kyber-db]
            [kyber.components.base.button :as button]
            [kyber.components.base.text :as text]
            [kyber.components.base.link :as link]
            [kyber.components.composite.loading :as loading]
            [kyber.components.composite.progress-bar :refer [loading-simulation]]
            [kyber.utils :as ku]
            [kyber.kyber-db.hr-manager-report-team-data :as hr-manager-report-team-data]
            [kyber.kyber-db.hr-manager-report-learner-data :as hr-manager-report-learner-data]
            [kyber.subscriptions.async-request :as async-req]
            [admin.constants :as c]
            [admin.router.utils :as aru]
            [admin.components.composite.resource-viewer :as resource-viewer]
            [admin.components.learner-reports.team-breakdown-sidebar
             :refer [team-breakdown-sidebar]]
            [admin.components.learner-reports.readiness
             :as learner-readiness]
            [admin.components.learner-reports.learning-objectives
             :as learning-objectives]
            [admin.components.learner-reports.mindset :as mindset]
            [admin.components.learner-reports.post-test-analysis
             :as post-test-analysis]
            [admin.components.learner-reports.learner-activity-moment-analysis
             :as learner-activity-moment-analysis]
            [admin.components.learner-reports.key-insights
             :as key-insights]
            [admin.events.containers.learner-reports-activity :as >learner-reports-activity]
            [admin.subscriptions.learner-reporting :as <learner-reporting]
            [admin.components.learner-reports.shared :as lrs]
            [admin.events.containers.learner-activity-report-mock :as mock]
            [admin.events.containers.learner-activity-report-alternate-mock :as alternate-mock]
            [admin.styles.constants :as sc]))

(def team-summary-max-width 750)
(def sidebar-width 500)
(def minimized-sidebar-width 60)

(def classes
  (styles->classes
   {:active-state-container
    {:padding (gs [:spacing :p20])
     :width "100%"
     :max-width (str c/page-max-width "px")
     :margin "0 auto"}

    :error-container
    {:display :flex
     :justify-content :center
     :align-items :center
     :flex-direction :column
     :width "100%"
     :margin :auto}

    :breadcrumb-link
    {:font-size (gs [:font-size :body-30])
     :color (gs [:colors :true-white])
     "&:hover"
     {:text-decoration :underline
      :color (gs [:colors :true-white])}}

    :charting-container
    {:padding [(gs [:spacing :p0])
               (gs [:spacing :p0])
               (gs [:spacing :p40])]}

    :card-container
    {:background-color (gs [:colors :true-white])
     :border-radius (gs [:radius :r3])}

    :half-container
    {:padding [(gs [:spacing :p40])
               (gs [:spacing :p20])]
     :display :grid
     :grid-gap (gs [:spacing :p40])
     :grid-template-columns "repeat(auto-fit, minmax(24rem, 1fr))"
     (gs [:queries :ie])
     {:display :block}}

    :full-card
    {:margin [(gs [:spacing :p0])
              (gs [:spacing :p20])
              (gs [:spacing :p40])
              (gs [:spacing :p20])]}

    :readiness-card
    {(gs [:queries :ie])
     {:margin-bottom (gs [:spacing :p40])}}

    :inactive-container
    {:display :flex
     :flex-direction :column
     :justify-content :center
     :text-align :center
     :width "100%"
     :max-width (str c/page-max-width "px")
     :min-height "100%"
     :margin "0 auto"}

    :not-authorized
    {:padding (gs [:spacing :p40])
     :display :flex
     :flex-grow 1
     :align-items :center
     :flex-direction :column
     :justify-content :center}

    :banner-container
    {:min-height (gs [:spacing :p64])
     :background (gs [:colors :primary-gray-700])
     :display :flex
     :align-items :center
     :padding [(gs [:spacing :p0])
               (gs [:spacing :p20])]}

    :header-links
    {:list-style :none
     :margin [(gs [:spacing :p8]) :auto]
     :width "100%"
     :display :flex
     :align-items :center
     "& > li"
     {:color (gs [:colors :true-white])
      :display :inline-block
      "&::after"
      {:content "\"\u00a0 / \u00a0\""
       :font-size (gs [:font-size :title-30])
       :color (gs [:colors :primary-gray-400])}
      "&:last-child::after"
      {:content "\"\""}}}

    :learner-name-container
    {:padding [(gs [:spacing :p0])
               (gs [:spacing :p20])]}
    :learner-container
    {:max-width (str c/page-max-width "px")
     :margin "0 auto"
     :padding [(gs [:spacing :p20])
               (gs [:spacing :p40])
               (gs [:spacing :p0])]}

    :team-summary-container
    {:display :flex
     :flex-direction :column
     :justify-content :space-around
     :text-align :center
     :width "100%"
     :min-height "100%"}

    :team-summary
    {:text-align :left
     :padding (gs [:spacing :p20])
     :max-width (str team-summary-max-width "px")
     :width "100%"
     :margin "0 auto"}

    :progress-bar-background
    {:width "100%"
     :position :relative}

    :progress-bar
    {:position :absolute}

    :learner-dashboard-outer-container
    {:display :flex
     :flex "1 1 auto"
     :position :relative}

    :learner-dashboard-sidebar-container
    {:position :absolute
     :top 0
     :bottom 0
     :overflow-y :scroll
     :z-index 1
     :width (str sidebar-width "px")
     :transition (str sc/learner-dashboard-sidebar-transition-time "ms ease-in-out")}

    :learner-dashboard-sidebar-minimized
    {:position :absolute
     :top 0
     :bottom 0
     :background-color (gs [:colors :true-white])
     :z-index 1
     :width (str minimized-sidebar-width "px")
     :transition  (str sc/learner-dashboard-sidebar-transition-time "ms ease-in-out")}

    :learner-dashboard-main-container
    {:position :absolute
     :padding [0
               (gs [:spacing :p20])]
     :top 0
     :bottom 0
     :left (str sidebar-width "px")
     :right 0
     :overflow-y :scroll
     :z-index 0}

    :loading-container
    {:display :flex
     :justify-content :center
     :align-items :center
     :width "100%"
     :min-height "calc(100vh - 100px)"
     :flex-direction :column}

    :loading-message
    {:text-align :center}}))

(def report-loading-message "Please wait while we generate your report…")

(defn- error-container []
  [:div {:class [(:error-container classes)]}
   [text/title-40 :p "Oh no... Something went wrong while loading your report."]
   [text/body-30 :p "Our team has been notified of this issue and will be looking into it shortly."]])

(defn- loading-data [{:keys [loading-message]}]
  [:div {:class (:loading-container classes)}
   [:<>
    (when (some? loading-message)
      [text/body-30 :p {:class [(:loading-message classes)]} loading-message])
    [loading/circles]
    [loading-simulation]]])

(defn- render-inactive-state []
  [:div {:class (:inactive-container classes)}
   [text/title-30 :p "Insufficient Data"]
   [text/title-10 :p
    "There was not enough data found to create this learner report. "]])

(defn- learner-report-header
  [{:keys [learner-uuid activity-uuid curriculum-uuid lmei]}
   {learner-name :external-user/full-name :as learner}]
  ;; Commented out code will be added back in after the pilot run with PRA
  (let [#_curriculum #_(re-frame/subscribe
                        [::kyber-db/get-record {:model :curriculum
                                                :ident curriculum-uuid}])
        activity (re-frame/subscribe
                  [::kyber-db/get-record {:model :activity
                                          :ident activity-uuid}])
        ;; {curriculum-name :curriculum/name} @curriculum
        {activity-name :activity/name} @activity
        append->lmei #(if (some? %2) (str %1 "?lmei=" %2) %1)]
    [:div {:class (:banner-container classes)}
     [:ul {:class (:header-links classes)}
      #_(when (not= "demo" activity-uuid)
          [:li [link/link {:href (append->lmei
                                  (aru/admin-path :curriculum-learner-reports-index
                                                  :curriculum-uuid curriculum-uuid)
                                  lmei)
                           :class (:breadcrumb-link classes)}
                curriculum-name]])

      (if (some? learner-uuid)
        [:li
         [link/link {:href (append->lmei
                            (aru/admin-path :learner-reports-activity
                                            :curriculum-uuid curriculum-uuid
                                            :activity-uuid activity-uuid)
                            lmei)
                     :class (:breadcrumb-link classes)}
          (str activity-name " ")]]
        [text/body-30 :li activity-name])
      (when (some? learner)
        [text/body-30 :li learner-name])]]))

(defn- learner-summary [{learner-data :learner/data
                         activity-uuid :activity/uuid
                         :activity/keys [plo-type]
                         :as report}]
  (let [chart-options {:supports-aggregates (or (= plo-type "video")
                                                (= activity-uuid "demo")
                                                (= activity-uuid "alternate-demo")
                                                (= activity-uuid "alternate-demo-v2"))}
        {:activity-session/keys [started-at]
         :external-user/keys [full-name]} learner-data]
    [:div {:class (:active-state-container classes)}
     [:div {:class (:learner-name-container classes)}
      [text/title-40 :p full-name]
      (when (some? started-at)
        [text/title-10 :p (str "Started on: "
                               (ku/date->day-string started-at))])]
     [:div {:class (:charting-container classes)}

      [:div {:class (:half-container classes)}
       [:div {:class [(:card-container classes)
                      (:readiness-card classes)]}
        [learner-readiness/render report chart-options]]

       [:div {:class (:card-container classes)}
        [mindset/render report chart-options]]]

      [:div {:class [(:card-container classes)
                     (:full-card classes)]}
       [learning-objectives/render report chart-options]]

      [:div {:class [(:card-container classes)
                     (:full-card classes)]}
       [post-test-analysis/render report chart-options]]

      [:div {:class [(:card-container classes)
                     (:full-card classes)]}
       [learner-activity-moment-analysis/render report chart-options]]]]))

(defn- team-readiness
  [{{:activity-session/keys [average-readiness average-team-readiness]} :user/staff-data
    :as report}
   {:keys [supports-aggregates]}]
  (when (some? report)
    [:div
     [:div
      [text/title-40 :h3 "Readiness"]
      [text/title-20 :p
       (str "Your team has an average readiness score of " (lrs/format-readiness average-readiness))]
      [:div {:class (:progress-bar-background classes)
             :style {:background-color (gs [:colors :true-white])
                     :height (gs [:spacing :p20])}}
       [:div {:style {:width (str (* 10 average-readiness) "%")
                      :height (gs [:spacing :p20])
                      :background-color (gs [:colors :primary-lite-600])}
              :class (:progress-bar classes)}]]]

     (when (true? supports-aggregates)
       [:div {:style {:margin-top (gs [:spacing :p8])}}
        [:div {:class (:progress-bar-background classes)
               :style {:background-color (gs [:colors :true-white])
                       :height (gs [:spacing :p8])}}
         [:div {:style {:width (str (* 10 average-team-readiness) "%")
                        :height (gs [:spacing :p8])
                        :background-color (gs [:colors :primary-gray-500])}
                :class (:progress-bar classes)}]]
        [text/title-10 :p {:style {:color (gs [:colors :primary-gray-600])}}
         (str "The average team score is " (lrs/format-readiness average-team-readiness))]])]))

(defn- team-summary [{:keys [activity-uuid] :as params} report plo-type]
  (let [sidebar-open? @(re-frame/subscribe [::<learner-reporting/sidebar-open?])]
    [:div {:class (:learner-dashboard-main-container classes)
           :style {:left (if sidebar-open?
                           (str sidebar-width "px")
                           (str minimized-sidebar-width "px"))}}
     [:div {:class (:team-summary-container classes)}
      [:div {:class (:team-summary classes)}
       [team-readiness report {:supports-aggregates (or (= plo-type "video")
                                                        (= activity-uuid "demo")
                                                        (= activity-uuid "alternate-demo")
                                                        (= activity-uuid "alternate-demo-v2"))}]
       [key-insights/render params report]]]]))

(defn- sidebar-container [params report]
  (let [sidebar-open? @(re-frame/subscribe [::<learner-reporting/sidebar-open?])]
    [:<>
     [:div {:class (:learner-dashboard-sidebar-minimized classes)
            :style {:transform (if sidebar-open?
                                 "translateX(-100%)"
                                 (str "translateX(0)"))}}
      [button/primary-button
       {:on-click #(re-frame/dispatch [:learner-reporting/toggle-sidebar])
        :style {:margin (gs [:spacing :p20])}}
       "Show"]]
     [:div {:class (:learner-dashboard-sidebar-container classes)
            :style {:transform (if sidebar-open?
                                 "translateX(0px)"
                                 (str "translateX(-" sidebar-width "px)"))}}
      [team-breakdown-sidebar params report]]]))

(defn- render-learner-report
  [{:keys [activity-uuid learner-uuid lmei] :as params}]
  (let [team-data-event-name
        ::>learner-reports-activity/fetch-team-container-data

        is-team-data-fetched
        @(re-frame/subscribe
          [::async-req/is-polling-complete?
           team-data-event-name])

        {team-request-error :error}
        @(re-frame/subscribe
          [:request/track-request
           team-data-event-name])

        {learner-request-status :status
         learner-request-error :error}
        @(re-frame/subscribe
          [:request/track-request
           ::>learner-reports-activity/fetch-learner-container-data])

        {activity-request-status :status
         activity-request-error :error}
        @(re-frame/subscribe
          [:request/track-request
           ::>learner-reports-activity/fetch-activity-report-metadata])

        is-dispatching-learner
        (= learner-request-status :loading)

        is-dispatching-activity
        (= activity-request-status :loading)

        sidebar-open?
        @(re-frame/subscribe [::<learner-reporting/sidebar-open?])

        ;; current-user in this context is the manager
        current-user
        (re-frame/subscribe [:authentication/user-attributes])

        activity
        @(re-frame/subscribe [::kyber-db/get-record
                              {:model :activity
                               :ident activity-uuid
                               :query [:activity/uuid
                                       :activity/moments
                                       :activity/post-test
                                       :activity/learning-objectives
                                       :activity/plo-type]}])

        report
        @(re-frame/subscribe [::kyber-db/get-record
                              {:model :hr-manager-report-team-data
                               :ident (hr-manager-report-team-data/->ident-key
                                       {:activity/uuid activity-uuid
                                        :user/uuid (or lmei (:sub @current-user))})}])

        learner-report
        @(re-frame/subscribe [::kyber-db/get-record
                              {:model :hr-manager-report-learner-data
                               :ident (hr-manager-report-learner-data/->ident-key
                                       {:activity/uuid activity-uuid
                                        :external-user/id learner-uuid})}])]  
    (cond
      (or (false? is-team-data-fetched)
          (true? is-dispatching-activity)
          ;; This is for the demo
          (and (or (= activity-uuid mock/activity-uuid)
                   (= activity-uuid mock/rater-activity-uuid)
                   (= activity-uuid alternate-mock/activity-uuid)
                   (= activity-uuid alternate-mock/activity-uuid-v2))
               (nil? report)))
      [loading-data {:loading-message report-loading-message}]

      (or (some? team-request-error)
          (some? learner-request-error)
          (some? activity-request-error))
      [error-container]

      :else
      [:<>
       [learner-report-header params learner-report]

       [:div {:class (:learner-dashboard-outer-container classes)}
        [sidebar-container params report]

        [:div {:class (:learner-dashboard-main-container classes)
               :style {:left (if sidebar-open?
                               (str sidebar-width "px")
                               (str minimized-sidebar-width "px"))}
               :key (:learner-uuid params)}
         (if (or (true? is-dispatching-learner)
                 (true? is-dispatching-activity)
                 (and (or (= activity-uuid mock/activity-uuid)
                          (= activity-uuid mock/rater-activity-uuid)
                          (= activity-uuid alternate-mock/activity-uuid)
                          (= activity-uuid alternate-mock/activity-uuid-v2))
                      (or (nil? learner-report)
                          (nil? report)
                          (nil? activity))))
           [loading-data {:loading-message report-loading-message}]
           (if (-> learner-report :activity-session/readiness some?)
             [learner-summary
              (merge
               {:learner/data learner-report}
               (select-keys report [:user/staff-data])
               (select-keys activity [:activity/uuid
                                      :activity/post-test
                                      :activity/moments
                                      :activity/learning-objectives
                                      :activity/plo-type]))]
             [render-inactive-state]))]]])))

(defn- render-learner-reports
  [{:keys [activity-uuid lmei] :as params}]
  (let [team-data-event-name
        ::>learner-reports-activity/fetch-team-container-data

        {:activity/keys [plo-type]}
        @(re-frame/subscribe [::kyber-db/get-record
                              {:model :activity
                               :ident activity-uuid
                               :query [:activity/plo-type]}])

        {team-request-error :error}
        @(re-frame/subscribe
          [:request/track-request
           team-data-event-name])

        {activity-request-status :status
         activity-request-error :error}
        @(re-frame/subscribe
          [:request/track-request
           ::>learner-reports-activity/fetch-activity-report-metadata])

        is-team-data-fetched
        @(re-frame/subscribe
          [::async-req/is-polling-complete?
           team-data-event-name])

        is-dispatching-activity
        (= activity-request-status :loading)

        ;; current-user in this context is the manager
        current-user
        (re-frame/subscribe [:authentication/user-attributes])

        report
        @(re-frame/subscribe [::kyber-db/get-record
                              {:model :hr-manager-report-team-data
                               :ident (hr-manager-report-team-data/->ident-key
                                       {:activity/uuid activity-uuid
                                        :user/uuid (or lmei (:sub @current-user))})}])]

    [:<>
     [learner-report-header params nil]
     [:div {:style {:flex "1 1 auto"
                    :display :flex}}
      (cond
        (or (false? is-team-data-fetched)
            (true? is-dispatching-activity))
        [loading-data {:loading-message report-loading-message}]

        (some? report)
        [:div {:class (:learner-dashboard-outer-container classes)}
         [sidebar-container params report]
         [team-summary params report plo-type]]

        (or (some? team-request-error)
            (some? activity-request-error))
        [error-container]

        :else
        [loading-data {:loading-message report-loading-message}])]]))

(defn render [{:keys [route-key params query]}]
  (let [params* (assoc params :lmei (get query "lmei"))]
    (case route-key
      :learner-reports-activity
      [render-learner-reports params*]

      :learner-reports-activity-learner
      [:<>
       [resource-viewer/render]
       [render-learner-report params*]]

      [:<>])))
